export default __webpack_public_path__ + "static/media/algo-icon.6bb89488.svg";